"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _react = _interopRequireDefault(require("react"));
var _Shimmer = _interopRequireDefault(require("./Shimmer"));
var _Map = _interopRequireDefault(require("./Map"));
var _Button = _interopRequireDefault(require("./Button"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Skeleton = function Skeleton(props) {
  return _react.default.createElement(_Shimmer.default, (0, _tslib.__assign)({}, props));
};
Skeleton.displayName = 'Skeleton';
Skeleton.Button = _Button.default;
Skeleton.Map = _Map.default;
var _default = Skeleton;
exports.default = _default;
{
  /*
  Ideal Usage:
  <Skeleton sx={ { width: 1 } } />
  <Text count="3" sx={ { width: 1 } } />
  <Button count="3" sx={ { width: '50%' } } />
  */
}